import { stringifyUrl } from 'src/utils/stringifyUrl';
import { useExternalHref } from 'src/hooks/useExternalHref';
import { useLanguagePairContext } from 'src/context/languagePair';

export const useCtaHref = (customNext?: string) => {
  return useExternalHref({
    linkType: 'memrise-signup',
    query: {
      ...(customNext ? { next: customNext } : {}),
    },
  });
};

export const useImmersiveVideoCtaHref = (mediaId: number) => {
  const { languagePairId } = useLanguagePairContext();

  return useCtaHref(
    stringifyUrl('/media', {
      languagePairId,
      contentMediaId: mediaId,
    }),
  );
};
